const ctxTableTreeModule = angular.module('com.comtrade.shared.sharedModule.ctxTableTree', [
    'ivh.treeview'
]);

ctxTableTreeModule.config(require('./ctxTableTree.ivh.treeview.config'));

ctxTableTreeModule.component('ctxTableTree', require('./ctxTableTree.component'));
ctxTableTreeModule.directive('ctxTableTreeviewCheckboxHelper', require('./customDirectives/ctxTableTreeviewCheckboxHelper.directive'));
ctxTableTreeModule.directive('ctxTableTreeviewCheckbox', require('./customDirectives/ctxTableTreeviewCheckbox.directive'));
ctxTableTreeModule.directive('ctxTableTreeviewChildren', require('./customDirectives/ctxTableTreeviewChildren.directive'));
ctxTableTreeModule.directive('ctxTableTreeviewNode', require('./customDirectives/ctxTableTreeviewNode.directive'));
ctxTableTreeModule.directive('ctxTableTreeviewToggle', require('./customDirectives/ctxTableTreeviewToggle.directive'));
ctxTableTreeModule.directive('ctxTableTreeviewTwistie', require('./customDirectives/ctxTableTreeviewTwistie.directive'));
ctxTableTreeModule.directive('ctxTableTreeview', require('./customDirectives/ctxTableTreeview.directive'));

module.exports = ctxTableTreeModule;


// WEBPACK FOOTER //
// ./src/shared/ctxTableTree/ctxTableTree.module.js